export const divideFields = fields => {
  return [
    fields.slice(0, Math.ceil(fields.length / 2)),
    fields.slice(Math.ceil(fields.length / 2)),
  ];
};